class ReviewsManager {

  currentPageRequestTimestamp = 0;
  currentPage = 1;
  maxPage;
  productId;
  reviewsContainer;

  _prevButton;
  _nextButton;

  requestsMidFlight = 0;

  overlayCssClass = "etrusted-reviews-loader-overlay";
  overlayCssSelector = "." + this.overlayCssClass;

  constructor(productId, maxPage, reviewsContainer) {
    this.maxPage = maxPage;
    this.productId = productId;
    this.reviewsContainer = reviewsContainer;

    this._prevButton = reviewsContainer.querySelector(".woocommerce-pagination .prev");
    this._nextButton = reviewsContainer.querySelector(".woocommerce-pagination .next");

    const container = jQuery(reviewsContainer);
    const thizz = this;

    /* The button might not be present if there's only one page of rewievs */
    if(this._prevButton) {
      jQuery(this._nextButton).on('click', function (e) {
        e.preventDefault();
        thizz.nextPage();
      });
    }

    if(this._nextButton) {
      jQuery(this._prevButton).on('click', function (e) {
        e.preventDefault();
        thizz.prevPage();
      });
    }

    this.markPositions();
  }

  nextPage = () => {
    /* Ignore the request if we reached last page */
    if(this.currentPage === this.maxPage) {
      return;
    }

    this.currentPage++;
    this.fetch_and_display_reviews(this.productId, this.currentPage);
    /**
     *  If we reached the last page, disable the next button.
     */
    this.markPositions();
  }

  prevPage = () => {
    /* Ignore the request if we reached the first page */
    if(this.currentPage === 1) {
      return;
    }

    this.currentPage--;
    this.fetch_and_display_reviews(this.productId, this.currentPage);
    /**
     * If we reached the first page disable the Prev button
     */
    this.markPositions();
  };

  markPositions = () => {

    const disableButton = (button) => {
      /**
       * For convenience reason button might be null - this means that the button isn't present on the page. In that
       * case we simply ignore the call
       */
      if(!button) {
        return;
      }

      // button.classList.add("disabled");
      // button.style.setProperty("color", "#e7e7e7", "important");
      button.style["visibility"] = "hidden";
    };

    const enableButton = (button) => {
      /**
       * For convenience reason button might be null - this means that the button isn't present on the page. In that
       * case we simply ignore the call
       */
      if(!button) {
        return;
      }

      // button.classList.remove("disabled");
      // button.style.removeProperty("color");
      button.style["visibility"] = "visible";
    };


    if(this.currentPage === 1) {
      /* Disable the Prev Page button */
      disableButton(this._prevButton);
    } else {
      enableButton(this._prevButton);
    }

    if(this.currentPage === this.maxPage) {
      /* Disable the Next Page button */
      disableButton(this._nextButton);
    } else {
      enableButton(this._nextButton);
    }

  };

  _markAsLoading = () => {
    const reviewsContainer = this.reviewsContainer.querySelector(".etrusted-reviews");
    /* If overlay already exists do nothing */
    if(this.reviewsContainer.querySelector(this.overlayCssClass)) {
      return;
    }

    const overlay = document.createElement("div");
    overlay.classList.add(this.overlayCssClass);
    Object.assign(overlay.style, {
      "position": "absolute",
      "top": 0,
      "left": 0,
      "width": "100%",
      "height": "100%",
      "opacity": 0.5,
      "z-index": 10,
      "background-color": "white"
    });

    reviewsContainer.style["position"] = "relative";
    reviewsContainer.appendChild(overlay);
  };

  _markAsLoaded = () => {
    /**
     *  If there are still some requests that are not processed don't remove the
     *  overlay
     */
    console.log("midfligh requests: " + this.requestsMidFlight);
    if(this.requestsMidFlight > 0) {
      return;
    }

    const overlay = this.reviewsContainer.querySelector(this.overlayCssSelector);
    if(overlay) {
      console.log("removing overlay");
      overlay.parentNode.removeChild(overlay);
    }
  };

  fetch_reviews_for_page = (productId, page) => {
    return jQuery.ajax(
      "/wp-json/etrusted/v1/product-reviews/" + productId,
      {
        dataType: 'json',
        data: { 'page': page }
      }
    ).then(function(data, state, jqXHR) {
      return data;
    });
  }

  fetch_and_display_reviews = (productId, page) => {
    var thizz = this;

    var timestamp = Date.now();

    this.requestsMidFlight++;
    this._markAsLoading();
    this.fetch_reviews_for_page(productId,page)
      .then(function(reviews) {
        /**
         * Ignore the request if it came after response for newer request. For
         * example, user may click on Next button twice, at time = 1 and time = 2
         * respectively for pages page=2 and page = 3. Due to asynchronous nature
         * of the requests we might first receive response for second request, and
         * after that response for the first. If we allow first request to update
         * the view then after clicking Next two times user would first briefly
         * see results for second page, then for the first.
         * @type {HTMLDivElement}
         */
        if(timestamp > thizz.currentPageRequestTimestamp ) {
          thizz.currentPageRequestTimestamp = timestamp;
          var reviewsContainer = thizz.constructReviews(reviews);
          var oldReviewsContainer = document.querySelector(".etrusted-reviews");
          if(oldReviewsContainer) {
            /* If original had overlay - copy it */
            const overlay = oldReviewsContainer.querySelector(thizz.overlayCssSelector)
            if(overlay) {
              reviewsContainer.style['position'] = "relative";
              reviewsContainer.appendChild(overlay);
            }

            oldReviewsContainer.parentNode.replaceChild(reviewsContainer, oldReviewsContainer);

          }
        }
      }).always(() => {
        /* Remove loading overlay even if it fails */
      this.requestsMidFlight--;
        thizz._markAsLoaded();
    });
  }

  constructReview = (review) => {
    var reviewEl = document.createElement("div");
    reviewEl.classList.add("etrusted-review");

    var reviewHead = document.createElement("div");
    reviewHead.classList.add("etrusted-review-head");

    var ratingContainer = document.createElement("div");
    ratingContainer.classList.add("etrusted-review-rating");

    var ratingList = document.createElement("ul");
    ratingList.classList.add("review-rating")

    if(review.rating === null) {
      // ratingList.innerHTML = '<span class="etrusted-missing-data">' + review.rating + "</span>";
    } else {
      var stars = Math.floor(review.rating + 0.5);
      for(var i = 0; i < 5; i++) {
        var starRating = document.createElement("li");
        var star = document.createElement("i");
        star.classList.add("fa", i < stars ? "fa-star" : "fa-star-o");
        starRating.appendChild(star);

        ratingList.appendChild(starRating);
      }
    }

    var reviewHeaderRight = document.createElement("div");
    reviewHeaderRight.classList.add("etrusted-review-right");
    var customer = document.createElement("div")
    customer.classList.add("etrusted-review-customer");
    customer.innerHTML = review.customer_name;

    var date = document.createElement("div");
    date.classList.add("etrusted-review-submitted");
    date.innerHTML = (new Date(review.date * 1000)).toLocaleDateString();

    var reviewBody = document.createElement("div");
    reviewBody.classList.add("etrusted-review-body");
    reviewBody.innerHTML = review.comment;

    ratingContainer.appendChild(ratingList);

    reviewHeaderRight.appendChild(customer);
    reviewHeaderRight.appendChild(date);

    reviewHead.appendChild(ratingContainer);
    reviewHead.appendChild(reviewHeaderRight);

    reviewEl.appendChild(reviewHead);
    reviewEl.appendChild(reviewBody);

    return reviewEl;
  }

  constructReviews = (reviews) => {
    var reviewsContainer = document.createElement("div");
    reviewsContainer.classList.add("etrusted-reviews");

    reviews.map(this.constructReview).forEach(function(review) {
      reviewsContainer.appendChild(review);
    });

    return reviewsContainer;
  };
}

jQuery(function() {
  const reviewsContainer = document.querySelector(".etrusted-wrapper");
  if(!reviewsContainer) {
    return;
  }
  const productId = parseInt(reviewsContainer.getAttribute("data-product-id"));
  const maxPages = parseInt(reviewsContainer.getAttribute("data-reviews-pages"));
  const reviewManager = new ReviewsManager(productId, maxPages, reviewsContainer);
});
